// extracted by mini-css-extract-plugin
module.exports = {"ResetGame":"ResetGame_ResetGame__1smCu"};